var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"dense":_vm.dense}},_vm._l((_vm.items),function(item,i){return _c('v-list-item',{key:i},[_c('v-list-item-content',[_c('span',{class:_vm.font},[_vm._v(_vm._s(item))])])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }